import { ChangeDetectionStrategy, Component, OnDestroy, signal, WritableSignal } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export abstract class BaseDashboardComponent implements OnDestroy {
  protected ngUnsubscribe = new Subject<void>();
  isLoading = signal<boolean>(true);

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  /**
   * Helper method to create a writable signal with proper typing
   */
  protected createSignal<T>(initialValue: T): WritableSignal<T> {
    return signal<T>(initialValue);
  }

  /**
   * Helper method to handle loading state changes
   */
  protected setLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }

  /**
   * Helper method to safely subscribe to observables with automatic cleanup
   */
  protected safeSubscribe<T>(
    observable: any,
    callback: (value: T) => void
  ): void {
    observable
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(callback);
  }
}
